import { Heading } from '@checkatrade/web-ui';

const HeaderEditMode = () => {
  return (
    <div className="justify-center">
      <Heading as="h3" variant="titleXS" className="my-4 text-center">
        Edit
      </Heading>
      <hr className="absolute left-0 w-full" />
    </div>
  );
};

export default HeaderEditMode;
